import { useNavigate } from "react-router-dom";
import { LayoutDashboard, X, Filter } from "lucide-react";

// Shown at the top of a list page when the user arrived via a Dashboard deep-link.
export default function FilterBanner({ label, count, onClear, action }) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border border-primary/20 bg-primary/5 px-4 py-2.5 text-sm" data-testid="dashboard-filter-banner">
      <Filter className="w-4 h-4 text-primary shrink-0" />
      <span className="text-muted-foreground">Filtered from Dashboard:</span>
      <span className="font-semibold">{label || "Selected records"}</span>
      {typeof count === "number" && <span className="text-xs text-muted-foreground">({count} record{count !== 1 ? "s" : ""})</span>}
      <div className="ml-auto flex items-center gap-3">
        {action}
        <button onClick={onClear} data-testid="banner-clear-filter" className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-red-500 transition-colors"><X className="w-3.5 h-3.5" /> Clear filter</button>
        <button onClick={() => navigate("/")} data-testid="banner-back-dashboard" className="inline-flex items-center gap-1.5 rounded-lg bg-primary text-primary-foreground px-3 py-1.5 text-xs font-medium hover:bg-primary/90 transition-colors"><LayoutDashboard className="w-3.5 h-3.5" /> Executive Dashboard</button>
      </div>
    </div>
  );
}
